// src/EtfHeatmapPage.js
import React from 'react';
import EtfHeatmap from './componets/EtfHeatmap';
import './HeatmapPage.css';

function EtfHeatmapPage() {
  return (
    <div className="heatmap-page">
      <h1>ETF Market Heatmap</h1>
      <div className="heatmap-container">
        <EtfHeatmap />
      </div>
    </div>
  );
}

export default EtfHeatmapPage;
